module.exports = {"540228100":"洛江镇","540228101":"嘎东镇","540228200":"巴扎乡","540228201":"玛乡","540228202":"旺丹乡","540228203":"曲奴乡","540228204":"杜琼乡","540228205":"强堆乡","540228206":"嘎普乡","540228207":"者下乡","540228208":"东喜乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540228.json
// module id = 2499
// module chunks = 0